import type { HelpFile } from '../../types/help'
import { ApprovalPolicyEditTestIds } from '../../../testids/ApprovalPolicyEditTestIds'

export const approvalPolicyEditHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyEditTestIds.approvalPolicyEditPage]: 'Edit an existing approval policy — adjust the scope, approver chain, and escalation rules used for matching access requests.',
  },
}
